import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { TimelineTeaseEntry } from "frontend/contentful/schema/blocks";
import {
  TimelineTease,
  TimelineTeaseProps,
} from "design-system/components/blocks/timeline-tease/timeline-tease";
import { createTimelineEventProps } from "../../primitives/timeline-event.props";
import { createComponentHeaderProps } from "../../primitives/component-header.props";

export const ContentfulTimelineTease =
  createContentfulComponent<TimelineTeaseEntry>(({ entry }) => {
    const props: TimelineTeaseProps = {
      events: [],
      header: createComponentHeaderProps(entry.fields.header),
      align: entry.fields.alignment,
    };

    entry.fields.timelineTeases?.forEach((event) => {
      const eventProps = createTimelineEventProps(event);
      if (eventProps) {
        props.events.push(eventProps);
      }
    });

    return <TimelineTease {...props} />;
  });
